import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import InfoCard from "./InfoCard";
import './CoursesSection.css';

const CoursesSection = () => {
  const navigate = useNavigate();
  
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <div className="next-arrow">›</div>,
    prevArrow: <div className="prev-arrow">‹</div>,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="courses-section">
      <div className="courses-header">
        <h2 className="courses-heading">Explore Our Courses</h2>
      </div>
      <p className="courses-header">
        Choose Your Course to Drive With Confidence On The Road.
      </p>
      <p className="courses-description">
        Our meticulously designed courses help transform beginners into skilled and confident drivers. Choose your desired course from a range of driving training courses and master the skill of driving at RDTC Singawal Driving School.
      </p>
      
      <Slider {...settings} className="courses-slider">
        <InfoCard
          title="One-Day Refresher Program"
          content="Empowering drivers with skill enhancement,certification, safety gear, and ₹1 lakh insurance under the One-Day Refresher Training Program."
          onLearnMore={() => navigate('/RefresherTraining')}
        />
        <InfoCard
          title="Pre-License Training Program"
          content="Upgrade from LMV to Heavy Vehicle License with 45 days of on-road training, simulator sessions, and medical certification under the Pre-License Program."
          onLearnMore={() => navigate('/PreLicenseProgram')}
        />
<InfoCard
  title="Saudi Skill Verification Program"
  content="Get prepared for the Saudi Arabia driving test with expert guidance and practical training."
  onLearnMore={() => navigate('/svp-program')}
/>
        <InfoCard
          title="Heavy Motor Vehicle Training Program"
          content="Comprehensive 21-day program designed to make you a skilled HMV driver under the official syllabus."
          onLearnMore={() => navigate('/hmv-course')}
        />
        <InfoCard
          title="Light Motor Vehicle Training Program"
          content="Quick and effective 21-day course for beginners and experienced drivers to master light vehicles."
          onLearnMore={() => navigate('/lmv-course')}
        />
        <InfoCard
          title="Motorcycle Training Program"
          content="Learn how to ride a motorcycle with confidence, tailored for new riders."
          onLearnMore={() => navigate('/motorcycle-course')}
        />

      </Slider>
    </section>
  );
};

export default CoursesSection;
